var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/profile_unselected.ebe0bc44.png","uri@2x": __webpack_public_path__ + "static/media/profile_unselected.943efd96.png","uri@3x": __webpack_public_path__ + "static/media/profile_unselected.077ae82f.png",
    width: 24,
    height: 24
});